"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const ScaleContext_1 = require("../../context/ScaleContext");
function StringNode({ signal, startY, levelHeight, fontSize, showLabels, }) {
    const { scaleX } = (0, ScaleContext_1.useScaleChecked)();
    return ((0, jsx_runtime_1.jsx)("text", { textAnchor: "middle", x: scaleX()(signal.delta), y: startY + levelHeight / 2, fontSize: fontSize, lengthAdjust: "spacing", fill: "black", visibility: showLabels ? 'visible' : 'hidden', children: signal.multiplicity }, `multiplicityString_${signal.id}`));
}
exports.default = StringNode;
